export enum ResetPasswordConfirmStatus {
  Inprogress = "Inprogress",
  OperationSuccess = "OperationSuccess",
  InvalidCode = "InvalidCode",
  CodeExpired = "CodeExpired",
  ResetPasswordRequestTaken = "ResetPasswordRequestTaken",
  UserPasswordExpired = "UserPasswordExpired",
}

export interface ResetPasswordInput {
  code: string;
}
